// extracted by mini-css-extract-plugin
module.exports = {"disabled":"PIMenu_disabled__1DnZf","enabled":"PIMenu_enabled__199HJ"};